export default __webpack_public_path__ + "8e22379205b84b052c3c4e562cbf8082.svg";